import { LayoutModule } from '@angular/cdk/layout';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MomentModule } from 'ngx-moment';
import { BlockUIModule } from 'ng-block-ui';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MaterialModule } from './core/utils/material.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './modules/login/login.component';
import { LogoutComponent } from './modules/logout/logout.component';
import { ForgotPasswordComponent } from './modules/forgot-password/forgot-password.component';
import { LoginService } from './services/login.service';
import { UserService } from './services/user.service';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { ErrorInterceptor } from './services/error.intercepter';
import { JwtInterceptor } from './services/jwt-intercepter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { InterceptorService } from './services/interceptor.service';
import { TokenStorageService } from './services/token-storage.service';
import { CustomPreloadingStrategy } from './customPreloader';
import { SharedModule } from './modules/shared/shared.module';
import {ToastrModule} from 'ngx-toastr';
import { FuseFlowComponent } from './modules/fuse-flow/fuse-flow.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxLoadingModule } from 'ngx-loading';
// import { ExtexcelviewerComponent } from './modules/i-forms/extraction/components/extexcelviewer/extexcelviewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
// import { ExtractionModule}  from './modules/i-forms/extraction/extraction.module';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ResetPasswordComponent } from './modules/reset-password/reset-password.component';
//import { PasswordStrengthComponent } from './modules/i-forms/user/password-strength/password-strength.component';
import { PasswordStrength } from './modules/i-forms/user/password-strength/password-strength.enum';
import { PasswordStrengthValidator } from './modules/i-forms/user/password-strength/password-strength.validator';
import { PasswordTest } from './modules/i-forms/user/password-strength/password-test.model';
//import { StrengthIndicatorComponent } from './modules/i-forms/user/password-strength/strength-indicator.component';
import { StrengthPasswordService } from './modules/i-forms/user/password-strength/strength-password.service';

import { ChangePasswordDialogComponent } from './modules/i-forms/user/change-password-dialog/change-password-dialog.component';
import { changePwdSharedModule } from './modules/i-forms/user/change-password-dialog/change-password-shared.module';
import { EulaSharedModule } from './modules/eula-dialog/eula-shared.module';
import { MfaComponent } from './modules/mfa/mfa.component';

//import { ChangePasswordDialogModule } from './modules/i-forms/user/change-password-dialog/change-password-dialog.module';

registerLocaleData(localeFr, 'fr');

const customNotifierOptions: NotifierOptions = {
	position: {
		  horizontal: {
			  position: 'right',
			  distance: 35
		  },
		  vertical: {
			  position: 'top',
			  distance: 50,
			  gap: 10
		  }
	  },
	theme: 'material',
	behaviour: {
	  autoHide: 3000,
	  onClick: 'hide',
	  onMouseover: 'pauseAutoHide',
	  showDismissButton: true,
	  stacking: 4
	},
	animations: {
	  enabled: true,
	  show: {
		preset: 'slide',
		speed: 300,
		easing: 'ease'
	  },
	  hide: {
		preset: 'fade',
		speed: 300,
		easing: 'ease',
		offset: 50
	  },
	  shift: {
		speed: 300,
		easing: 'ease'
	  },
	  overlap: 150
	}
};

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        LogoutComponent,
        MfaComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        FuseFlowComponent,
        //ChangePasswordDialogComponent,
        //PasswordStrengthComponent,
        //StrengthIndicatorComponent,

        // ExtexcelviewerComponent
    ],
    exports: [
        // ExtexcelviewerComponent,
        PdfViewerModule,
        // PasswordStrengthComponent,
        // StrengthIndicatorComponent,
         //ChangePasswordDialogComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        LayoutModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        AppRoutingModule,
        MomentModule,
        NotifierModule.withConfig(customNotifierOptions),
        MatDatepickerModule,
        MatSlideToggleModule,
        MatNativeDateModule,
        BlockUIModule.forRoot({
            message: 'Please wait'
        }),
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-top-right'
        }),
        NgIdleKeepaliveModule.forRoot(),
        SharedModule,
        NgxSpinnerModule,
        NgxLoadingModule.forRoot({}),
        PdfViewerModule,
        // ExtractionModule
           //ChangePasswordDialogModule,
        changePwdSharedModule,
        EulaSharedModule

    ],
    providers: [
        LoginService,
        UserService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        InterceptorService,
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        TokenStorageService,
        CustomPreloadingStrategy
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
	constructor(private dateAdapter: DateAdapter<Date>) {
    dateAdapter.setLocale("en-in"); // DD/MM/YYYY
  }
}
